export default {
    LIVE_RESERVATION_SELECTION_GET_RESERVATIONS_REQUEST: 'LIVE_RESERVATION_SELECTION_GET_RESERVATIONS_REQUEST',
    LIVE_RESERVATION_SELECTION_GET_RESERVATIONS_SUCCESS: 'LIVE_RESERVATION_SELECTION_GET_RESERVATIONS_SUCCESS',

    LIVE_RESERVATION_SELECTION_DISPOSE_STORE: 'LIVE_RESERVATION_SELECTION_DISPOSE_STORE',
};
